<div class="d-flex mb-2 align-items-center flex-wrap" *ngIf="isLoadDQT">
    <div class="row myw-grid mb-5">
        <div class="col-12 col-lg-7">
            <div class="card iom-dq-card">
                <div class="card-body">
                    <p class="iom-card-para">
                        Data quality assessment (DQA) is the process of scientifically and statistically evaluating data
                        in order to determine whether they meet the quality required for performing analysis and
                        intelligent automation.
                    </p>
                </div>
            </div>
        </div>
        <div class="col-12 col-lg-5">
            <div class="card iom-dq-card">
                <div class="card-header">
                    <div class="card-title pt-2">DATA QUALITY PERCENTAGE (INDEX) - {{inputDQT}}%</div>
                </div>
                <div class="card-body" id="container_0">
                    <div *ngIf='inputDataQuality != undefined'>
                        <app-speedometer-chart [input]="inputDataQuality"></app-speedometer-chart>
                    </div>
                </div>
                <div class="card-footer" style="text-align: center;" *ngIf="isProceed" id="btnProceedAbort">
                    <button [attr.disabled]="isDisabled == true ? 'disabled' : null" type="button" style="cursor: pointer;" class="btn btn-secondary mr-3" (click)="AbortDQT()">
                        Abort
                    </button>
                    <button [attr.disabled]="isDisabled == true ? 'disabled' : null" type="submit" class="btn btn-primary" style="cursor: pointer;" (click)="ProceedDQT()">
                        Proceed
                    </button>
                </div>
            </div>
        </div>
        <div class="col-12 col-lg-6 col-xl-3">
            <div class="card iom-dq-card">
                <div class="card-header">
                    <div class="card-title pt-2">Data Completeness</div>
                </div>
                <div class="card-body1">
                    <div *ngIf='inputDataCompleteness != undefined' id="container_1">
                        <app-speedometer-chart [input]="inputDataCompleteness"></app-speedometer-chart>
                    </div>
                    <p class="fs-12">
                        The degree to which all the required data values appear in the data record or business object.
                        This can be tracked by the percentage of records missing one or more required attributes.
                    </p>
                </div>
                <div *ngIf="this.abort != true" id="complete" class="card-footer">
                    <a href="javascript:;" (click)="loadDataCompleteness()"
                        [ngClass]="{active: isLoadDataCompleteness }" style="cursor: pointer;">
                        <span class="text-nowrap">Learn More</span>
                    </a>
                </div>
            </div>
        </div>
        <div class="col-12 col-lg-6 col-xl-3">            
            <div class="card iom-dq-card">
                <div class="card-header">
                    <div class="card-title pt-2">Data Redundancy</div>
                </div>
                <div class="card-body1">
                    <div *ngIf='inputDataRedundancy != undefined' id="container_2">
                        <app-speedometer-chart [input]="inputDataRedundancy"></app-speedometer-chart>
                    </div>
                    <p class="fs-12">
                        Data redundancy occurs when the same piece of data exists in multiple places. Duplicate ticket
                        IDs, duplicate columns are covered here
                        <br>
                        <br>
                    </p>
                </div>
                <div *ngIf="this.abort != true" id="redundancy" class="card-footer">
                    <a href="javascript:;" (click)="loadDataRedundancy()" [ngClass]="{active: isLoadDataRedundancy }"
                        style="cursor: pointer;">
                        <span class="text-nowrap">Learn More</span>
                    </a>
                </div>
            </div>
        </div>
        <div class="col-12 col-lg-6 col-xl-3">
            <div class="card iom-dq-card">
                <div class="card-header">
                    <div class="card-title pt-2">Data Validity</div>
                </div>
                <div class="card-body1">
                    <div *ngIf='inputDataValidity != undefined' id="container_3">
                        <app-speedometer-chart [input]="inputDataValidity"></app-speedometer-chart>
                    </div>
                    <p class="fs-12">
                        Data check to ensure that the data entered is sensible and reasonable. Correct format and data
                        type for each column should be checked
                    <br>
                    <br>
                    <br>
                    </p>
                </div>
                <div *ngIf="this.abort != true" id="validity" class="card-footer">
                    <a href="javascript:;" (click)="loadDataValidity()" [ngClass]="{active: isLoadDataValidity }"
                        style="cursor: pointer;">
                        <span class="text-nowrap">Learn More</span>
                    </a>
                </div>
            </div>
        </div>
        <div class="col-12 col-lg-6 col-xl-3">
            <div class="card iom-dq-card">
                <div class="card-header">
                    <div class="card-title pt-2">Data Clarity</div>
                </div>
                <div class="card-body1">
                    <div *ngIf='inputDataClarity != undefined' id="container_4">
                        <app-speedometer-chart [input]="inputDataClarity"></app-speedometer-chart>
                    </div>
                    <p class="fs-12">
                        The quality analysis of description of tickets. 
                        <br>
                        <br>
                        <br>
                        <br>
                        <br>
                    </p>
                </div>
                <div *ngIf="this.abort != true" id="clarity" class="card-footer">
                    <a href="javascript:;" (click)="loadDataClarity()" [ngClass]="{active: isLoadDataClarity }"
                        style="cursor: pointer;">
                        <span class="text-nowrap">Learn More</span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>
<!--1st Tab-->
<div class="d-flex mb-2 align-items-center flex-wrap" *ngIf="isLoadDataCompleteness">
    <div class="iom-subnavbar">
        <div class="align-items-center d-flex flex-wrap">
            <a class="subnav-btn" (click)="loadDataCompleteness()" [ngClass]="{active: isLoadDataCompleteness }"
                style="cursor: pointer;">
                <span class="text-nowrap">Data Completeness<span
                        class="iom-subnav-percent">&nbsp;{{inputDataCompleteness[0]}}%</span></span>
            </a>
            <a class="subnav-btn" (click)="loadDataRedundancy()" [ngClass]="{active: isLoadDataRedundancy }"
                style="cursor: pointer;">
                <span class="text-nowrap">Data Redundancy<span
                        class="iom-subnav-percent">&nbsp;{{inputDataRedundancy[0]}}%</span></span>
            </a>
            <a class="subnav-btn" (click)="loadDataValidity()" [ngClass]="{active: isLoadDataValidity }"
                style="cursor: pointer;">
                <span class="text-nowrap">Data Validity<span
                        class="iom-subnav-percent">&nbsp;{{inputDataValidity[0]}}%</span></span>
            </a>
            <a class="subnav-btn" (click)="loadDataClarity()" [ngClass]="{active: isLoadDataClarity }"
                style="cursor: pointer;">
                <span class="text-nowrap">Data Clarity<span
                        class="iom-subnav-percent">&nbsp;{{inputDataClarity[0]}}%</span></span>
            </a>
        </div>
    </div>
    <div class="d-flex mt-3" style="padding-left: 780px;">
        <div class="form-group ml-auto mb-0">
            <div class="form-inline fs-12">
                <label class="myw-checkbox myw-radio"><input type="radio" name="field-select" value="1" 
                    (click)="loadMandate(true)" checked><span class="d-flex align-items-center">Mandatory Field</span></label>
                <label class="myw-checkbox myw-radio"><input
                        [attr.disabled]="dualaxischartNonMandate.length == 0 ? 'disabled' : null" type="radio"
                        name="field-select" value="2" 
                        (click)="loadMandate(false)"><span class="d-flex align-items-center">Non-Mandatory Field</span></label>
            </div>
        </div>
    </div>

    <div class="row myw-grid">
        <div class="col-12 col-lg">
            <div class="card iom-dq-card">
                <div class="iom-dq-row p-3">
                    <div class="iom-dq-vs-col">
                        <div *ngIf='dualaxischart != undefined && dualaxischart.length != 0' class="iom-dq-card-title">
                            Blank fields vs Column name</div>
                        <div class="d-flex flex-column" id="dualaxisbar" style="height: 177px;">
                            <div *ngIf='dualaxischart != undefined && dualaxischart.length != 0'>
                                <app-3d-bar-chart [GraphData]="dualaxischart">
                                </app-3d-bar-chart>
                            </div>
                        </div>                    
                        <div class="d-flex align-items-center justify-content-center iom-legends">
                            <div *ngIf='dualaxischart != undefined && dualaxischart.length != 0'>
                                <div class="myw-legends">
                                    <i style="background-color:#A260B7;"></i>
                                    <span class="fs-10">No of Tickets</span>
                                </div>
                                <div class="myw-legends">
                                    <i style="background-color:#67B7DC;"></i>
                                    <span class="fs-10">Percentage</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="iom-dq-relevance-col">
                        <div *ngIf='columnRelevance != undefined && columnRelevance.length != 0'>
                            <div class="iom-dq-card-title">Column Relevance</div>
                            <div class="d-flex flex-column" *ngFor="let t of columnRelevance">
                                <div class="iom-col-relevance-container"
                                    (click)="GetFieldsData((t.Ticket_Count),t.ChartId,1)" style="cursor: pointer;">
                                    <span class="text-center" style="width:50px;">{{t.Ticket_Count}}</span>
                                    <span class="text-center">{{t.Column}}</span>
                                    <br>
                                </div>
                                <div style="height:20px"></div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg-7">
                        <div class="card-body">
                            <div *ngIf='graphDataCompleteness != undefined && graphDataCompleteness.length != 0'>
                                <div class="iom-dq-card-title">
                                    Unique values vs Column name
                                </div>
                            </div>
                            <div class="iom-dq-bar-chart" id="containerDQT">
                                <div *ngIf='graphDataCompleteness != undefined && graphDataCompleteness.length != 0'>
                                    <app-column-chart [GraphData]="graphDataCompleteness"
                                        [chartContainer]="container"></app-column-chart>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-lg-auto" >
            <div class="card iom-dq-card h-auto" >
                <div class="card-header" *ngIf="nonzerovalue" >
                    <div class="card-title mb-0" *ngIf="isColumnRelevance">{{columnRelevanceLabel}}</div>
                </div>
                <div class="card-body pt-0" *ngIf="!isColumnRelevance && nonzerovalue" > Please Select any one of the option </div>
                <div class="card-body pt-0" *ngIf="isColumnRelevance">
                    <div class="table-responsive iom-field-table myw-scrollbar">
                        <table class="table table-striped table-vmiddle myw-table fs-12">
                            <thead>
                                <tr>
                                    <th scope="col" class="text-center">SL.No</th>
                                    <th scope="col" class="text-center">Column Name</th>
                                    <th *ngIf="columnRelevanceLabel != 'Field with more unique data'" scope="col"
                                        class="text-center">%Blank</th>
                                </tr>
                            </thead>
                            <tbody *ngFor="let t of dataCompletenessMandate">
                                <tr>
                                    <td class="text-center">{{t.Sno}}</td>
                                    <td class="text-center">{{t.Column}}</td>
                                    <td *ngIf="columnRelevanceLabel != 'Field with more unique data'"
                                        class="text-center">{{t.percentage_null_count}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="card iom-dq-card">
                <div class="card-body">
                    <ol class="fs-12 m-0">
                        <li>Mandate the fields, which are required for analytics (so as to derive strong, meaningful and
                            accurate business insights).</li>
                        <li>Enable pre-population of basic fields based on rules and Machine Learning.</li>
                        <li>Add drop downs against the fields wherever possible.</li>
                    </ol>
                </div>
            </div>
        </div>
    </div>
</div>
<!--2nd Tab-->
<div class="d-flex mb-2 align-items-center flex-wrap" *ngIf="isLoadDataRedundancy">
    <div class="iom-subnavbar">
        <div class="align-items-center d-flex flex-wrap">
            <a class="subnav-btn" (click)="loadDataCompleteness()" [ngClass]="{active: isLoadDataCompleteness }"
                style="cursor: pointer;">
                <span class="text-nowrap">Data Completeness<span
                        class="iom-subnav-percent">&nbsp;{{inputDataCompleteness[0]}}%</span></span>
            </a>
            <a class="subnav-btn" (click)="loadDataRedundancy()" [ngClass]="{active: isLoadDataRedundancy }"
                style="cursor: pointer;">
                <span class="text-nowrap">Data Redundancy<span
                        class="iom-subnav-percent">&nbsp;{{inputDataRedundancy[0]}}%</span></span>
            </a>
            <a class="subnav-btn" (click)="loadDataValidity()" [ngClass]="{active: isLoadDataValidity }"
                style="cursor: pointer;">
                <span class="text-nowrap">Data Validity<span
                        class="iom-subnav-percent">&nbsp;{{inputDataValidity[0]}}%</span></span>
            </a>
            <a class="subnav-btn" (click)="loadDataClarity()" [ngClass]="{active: isLoadDataClarity }"
                style="cursor: pointer;">
                <span class="text-nowrap">Data Clarity<span
                        class="iom-subnav-percent">&nbsp;{{inputDataClarity[0]}}%</span></span>
            </a>
        </div>
    </div>
    <div class="row myw-grid my-4">
        <div class="col-12 col-lg-6 col-xl-4">
            <div class="card iom-dq-card">
                <div class="card-header">
                    <div class="card-title pt-2">Duplicate Tickets</div>
                </div>
                <div class="card-body">
                    <div class="py-2" style="height: 152px;">
                        <div class="col-auto pr-0">
                            <div class="iom-piedgram">
                                <svg width="100%" height="100%" viewBox="0 0 42 42" style="margin-left: 60px;">
                                    <circle r="15.91549430918954" cx="21" cy="21" fill="transparent" stroke="#edecfe"
                                        stroke-width="3"></circle>
                                    <circle r="15.91549430918954" cx="21" cy="21" fill="transparent" stroke="#a2a1fb"
                                        stroke-width="3"
                                        [attr.stroke-dasharray]="duplicateTicketsPercentage + ' ' + (100 - duplicateTicketsPercentage)"
                                        stroke-dashoffset="25"></circle>
                                </svg>
                                <p><strong style="margin-left: 125px;">{{duplicateTicketsPercentage}}%</strong><br />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <div class="iom-col-relevance-container" (click)="GetFieldsData(duplicateTicketsCount,1,2)"
                        style="cursor: pointer;">
                        <span>{{duplicateTicketsCount}}</span>
                        <span>Count of duplicates</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-lg-6 col-xl-4">
            <div class="card iom-dq-card">
                <div class="card-header">
                    <div class="card-title pt-2">Redundant Fields</div>
                </div>
                <div class="card-body pb-0" id="mlabelpie0">
                    <div class="col-12 col-lg-6 col-xl-6">
                        <div class="align-items-center justify-content-center">
                            <div *ngIf='graphDataRedundancy != undefined && graphDataRedundancy.length != 0'>
                                <app-multilevel-piechart [GraphData]="graphDataRedundancy" [categoryId]=0>
                                </app-multilevel-piechart>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <div class="d-flex">
                        <div class="iom-col-relevance-container mr-2" (click)="GetFieldsData(similarFieldsCount,2,2)"
                            style="cursor: pointer;">
                            <span>{{similarFieldsCount}}</span>
                            <span>Count of Redundant Fields</span>
                        </div>
                        <div class="iom-col-relevance-container" (click)="GetFieldsData(duplicateFieldsCount,3,2)"
                            style="cursor: pointer;">
                            <span>{{duplicateFieldsCount}}</span>
                            <span>Count of Duplicate Fields</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-lg-6 col-xl-4">

            <!-- <div class="card-body pt-0" *ngIf="!isDuplicateColumns && !isDuplicateColumnCount && !isSimilarColumns">
                Please Select any one of the option </div> -->

            <div class="card iom-dq-card" *ngIf="isDuplicateColumnCount">
                <div class="card-header">
                    <div class="card-title pt-2 mb-0">Duplicate Columns</div>
                </div>
                <div class="card-body pt-0">
                    <div class="table-responsive iom-field-table myw-scrollbar">
                        <table class="table table-striped table-vmiddle myw-table fs-12">
                            <thead>
                                <tr>
                                    <th scope="col" class="text-center">SL.No</th>
                                    <th scope="col" class="text-center">Incident ID</th>
                                    <th scope="col" class="text-center">Count</th>
                                </tr>
                            </thead>
                            <tbody *ngFor="let t of dataRedundancySimilarColumns">
                                <tr>
                                    <td class="text-center">{{t.Sno}}</td>
                                    <td class="text-center">{{t.IncidentNumber}}</td>
                                    <td class="text-center">{{t.TicketCount}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="card iom-dq-card" *ngIf="isSimilarColumns">
                <div class="card-header">
                    <div class="card-title pt-2 mb-0">Redundant Fields</div>
                </div>
                <div class="card-body pt-0">
                    <div class="table-responsive iom-field-table myw-scrollbar">
                        <table class="table table-striped table-vmiddle myw-table fs-12">
                            <thead>
                                <tr>
                                    <th scope="col" class="text-center">SL.No</th>
                                    <th scope="col" class="text-center">Column Name</th>
                                </tr>
                            </thead>
                            <tbody *ngFor="let t of dataRedundancySimilarColumns">
                                <tr>
                                    <td class="text-center">{{t.Sno}}</td>
                                    <td class="text-center">{{t.ColumnName}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="card iom-dq-card" *ngIf="isDuplicateColumns">
                <div class="card-header">
                    <div class="card-title pt-2 mb-0">Duplicate Columns</div>
                </div>
                <div class="card-body pt-0">
                    <div class="table-responsive iom-field-table myw-scrollbar">
                        <table class="table table-striped table-vmiddle myw-table fs-12">
                            <thead>
                                <tr>
                                    <th scope="col" class="text-center">SL.No</th>
                                    <th scope="col" class="text-center">Column Name</th>
                                </tr>
                            </thead>
                            <tbody *ngFor="let t of dataRedundancySimilarColumns">
                                <tr>
                                    <td class="text-center">{{t.Sno}}</td>
                                    <td class="text-center">{{t.ColumnName}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 mt-4">
            <div class="card iom-dq-card">
                <div class="card-body">
                    <ol class="fs-12 m-0">
                        <li>Minimize the number of fields in the Ticketing Tool (based on usefulness of data), which
                            will help in operational ease and reduce processing time of data while performing data
                            analysis.
                        </li>
                    </ol>
                </div>
            </div>
        </div>
    </div>
</div>
<!--3rd Tab-->
<div class="d-flex mb-2 align-items-center flex-wrap" *ngIf="isLoadDataValidity">
    <div class="iom-subnavbar">
        <div class="align-items-center d-flex flex-wrap">
            <a class="subnav-btn" (click)="loadDataCompleteness()" [ngClass]="{active: isLoadDataCompleteness }"
                style="cursor: pointer;">
                <span class="text-nowrap">Data Completeness<span
                        class="iom-subnav-percent">&nbsp;{{inputDataCompleteness[0]}}%</span></span>
            </a>
            <a class="subnav-btn" (click)="loadDataRedundancy()" [ngClass]="{active: isLoadDataRedundancy }"
                style="cursor: pointer;">
                <span class="text-nowrap">Data Redundancy<span
                        class="iom-subnav-percent">&nbsp;{{inputDataRedundancy[0]}}%</span></span>
            </a>
            <a class="subnav-btn" (click)="loadDataValidity()" [ngClass]="{active: isLoadDataValidity }"
                style="cursor: pointer;">
                <span class="text-nowrap">Data Validity<span
                        class="iom-subnav-percent">&nbsp;{{inputDataValidity[0]}}%</span></span>
            </a>
            <a class="subnav-btn" (click)="loadDataClarity()" [ngClass]="{active: isLoadDataClarity }"
                style="cursor: pointer;">
                <span class="text-nowrap">Data Clarity<span
                        class="iom-subnav-percent">&nbsp;{{inputDataClarity[0]}}%</span></span>
            </a>
        </div>
    </div>
    <div class="row myw-grid my-4">
        
        <div class="col-12 col-lg-8" *ngIf="IsDisplayMessageValidity != 1">
            <div class="card iom-dq-card">
                <div class="card-header">
                    <div class="card-title mb-0">Missing Information Metrics</div>
                </div>
                <div class="card-body" id="container0">
                    <div *ngIf='graphDataValidity != undefined && graphDataValidity.length != 0'>
                        <app-horizontal-bar-chart [GraphData]="graphDataValidity">
                        </app-horizontal-bar-chart>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-lg-4" *ngIf="IsDisplayMessageValidity != 1">
            <div class="card iom-dq-card">
                <div class="card-header">
                    <div class="card-title mb-0">Negative TAT</div>
                </div>
                <div class="card-body" id="mlabelpieDQT0">
                    <div *ngIf='graphDataValidity != undefined && graphDataValidity.length != 0'>
                        <app-horizontal-bar-chart [GraphData]="graphDataValidity">
                        </app-horizontal-bar-chart>
                    </div>
                </div>
                <div class="d-flex align-items-center justify-content-center iom-legends">
                    <div>
                        <div class="myw-legends">
                            <i style="background-color:#E370B3;"></i>
                            <span class="fs-12">Negative TAT</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12" *ngIf="tabelDataValidity.length != 0">
            <div class="card iom-dq-card">
                <div class="card-header">
                    <div class="card-title mb-0">{{tabelDataValidityLabel}} (Top 5 Counts)</div>
                </div>
                <div class="card-body pt-0">
                    <div class="table-responsive iom-field-table myw-scrollbar">
                        <table class="table table-striped table-vmiddle myw-table fs-12">
                            <thead>
                                <tr>
                                    <th class="text-center" scope="col">Incident Number</th>
                                    <th class="text-center" scope="col">Created Date</th>
                                    <th class="text-center" scope="col">Closed Date</th>
                                    <th class="text-center" *ngIf="chartTypeDataValidity == 1" scope="col">SLA Resolution</th>
                                    <th class="text-center" *ngIf="chartTypeDataValidity == 2" scope="col">Resolution Description</th>
                                    <th class="text-center" *ngIf="chartTypeDataValidity == 3" scope="col">Effort</th>
                                    <th class="text-center" *ngIf="chartTypeDataValidity == 4" scope="col">Status</th>
                                </tr>
                            </thead>
                            <tbody *ngFor="let t of tabelDataValidity">
                                <tr>
                                    <td class="text-center">{{t.IncidentNumber}}</td>
                                    <td class="text-center">{{t.ReportedDateTime}}</td>
                                    <td class="text-center">{{t.TicketClosedDate}}</td>
                                    <td class="text-center" *ngIf="chartTypeDataValidity == 1">{{t.SLAResolution}}</td>
                                    <td class="text-center" *ngIf="chartTypeDataValidity == 2">{{t.ResolutionDescription}}</td>
                                    <td class="text-center" *ngIf="chartTypeDataValidity == 3">{{t.Effort}}</td>
                                    <td class="text-center" *ngIf="chartTypeDataValidity == 4">{{t.Status}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 mt-4" *ngIf="IsDisplayMessageValidity == 1">
            <div class="card iom-dq-card">
                <div class="card-body">
                    <ol class="m-0 fs-15">
                        Ticket closed date is empty or not mapped in the tickets uploaded. Please map ticket closed date to populate data validity score.
                    </ol>
                </div>
            </div>
        </div>
        <div class="col-12 mt-4">
            <div class="card iom-dq-card">
                <div class="card-body">
                    <ol class="m-0 fs-12">
                        <li>Updating RESOLVED DATE/ CLOSED DATE/ CLOSE CODE/ SLA STATUS, should be mandated for all
                            completed tickets.</li>
                        <li>Presence of resolution description for closed tickets helps in gaining further insights
                            about the ticket which helps in generating accurate repetitive patterns</li>
                        <li>Mandate creation and Closed date for all tickets and use date time format</li>
                        <li>Make sure Closed date is greater than creation date to prevent negative Turn around time.
                        </li>
                    </ol>
                </div>
            </div>
        </div>
    </div>
</div>
<!--4th Tab-->
<div class="d-flex mb-2 align-items-center flex-wrap" *ngIf="isLoadDataClarity">
    <div class="iom-subnavbar">
        <div class="align-items-center d-flex flex-wrap">
            <a class="subnav-btn" (click)="loadDataCompleteness()" [ngClass]="{active: isLoadDataCompleteness }"
                style="cursor: pointer;">
                <span class="text-nowrap">Data Completeness<span
                        class="iom-subnav-percent">&nbsp;{{inputDataCompleteness[0]}}%</span></span>
            </a>
            <a class="subnav-btn" (click)="loadDataRedundancy()" [ngClass]="{active: isLoadDataRedundancy }"
                style="cursor: pointer;">
                <span class="text-nowrap">Data Redundancy<span
                        class="iom-subnav-percent">&nbsp;{{inputDataRedundancy[0]}}%</span></span>
            </a>
            <a class="subnav-btn" (click)="loadDataValidity()" [ngClass]="{active: isLoadDataValidity }"
                style="cursor: pointer;">
                <span class="text-nowrap">Data Validity<span
                        class="iom-subnav-percent">&nbsp;{{inputDataValidity[0]}}%</span></span>
            </a>
            <a class="subnav-btn" (click)="loadDataClarity()" [ngClass]="{active: isLoadDataClarity }"
                style="cursor: pointer;">
                <span class="text-nowrap">Data Clarity<span
                        class="iom-subnav-percent">&nbsp;{{inputDataClarity[0]}}%</span></span>
            </a>
        </div>
    </div>
    <div class="d-flex mt-3" style="padding-left: 700px;">
        <div class="form-group ml-auto mb-0">
            <div class="form-inline fs-12"  *ngIf="IsDisplayMessageClarity != 1">
                <label class="myw-checkbox myw-radio"><input
                        [attr.disabled]="dataClarityResolnDesc.length == 0 || !isResolutionDescEnabledTask? 'disabled' : null" type="radio"
                        name="description-select" value="1" (click)="toggleDataClarity('Resolution')" [checked]="dataClarityDescType == 0"><span
                        class="d-flex align-items-center">Resolution Description</span></label>
                <label class="myw-checkbox myw-radio"><input
                        [attr.disabled]="dataClarityShortDesc.length == 0 ? 'disabled' : null" type="radio"
                        name="description-select" value="2" (click)="toggleDataClarity('Short')" [checked]="dataClarityDescType == 1"><span
                        class="d-flex align-items-center">Short Description</span></label>
                <label class="myw-checkbox myw-radio"><input
                            [attr.disabled]="dataClarityQualifiedDesc.length == 0 ? 'disabled' : null" type="radio"
                            name="description-select" value="3" (click)="toggleDataClarity('')" [checked]="dataClarityDescType == 2"><span
                            class="d-flex align-items-center">{{this.descriptionName}}</span></label>
            </div>
        </div>
    </div>
    <div class="row myw-grid">
        <div class="col-12 col-lg-5" *ngIf="IsDisplayMessageClarity != 1">
            <div class="card iom-dq-card">
                <div class="card-header">
                    <div class="card-title mb-0">{{this.header}}</div>
                </div>
                <div class="card-body d-flex flex-column">
                    <div *ngIf='GraphData != undefined' id="doughnutChart">
                        <app-doughnut-clickable-chart [GraphData]="GraphData"></app-doughnut-clickable-chart>
                    </div>
                </div>
            </div>
        </div>   
        <div class="col-12 col-lg" *ngIf="IsDisplayMessageClarity != 1">           
            <div class="card iom-dq-card h-auto">
                <div class="card-header">
                    <div class="card-title mb-0">{{wordCloudLabel}}</div>
                </div>
                <div class="card-body">
                    <div class="col-12 col-lg" *ngIf="!wordCloudDataDQT" > Please click on Description Words Chart to view the Word cloud.
                    </div>  
                    <div  *ngIf="wordCloudDataDQT != null && wordCloudDataDQT != undefined" id="containerwordCloudDQT">
                        <app-word-chart [ContainerId]="containerwordCloudDQT" [GraphData]="wordCloudDataDQT"
                            [wordlength]="1"></app-word-chart>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12" *ngIf="IsDisplayMessageClarity == 1">
            <div class="card iom-dq-card">
                <div class="card-body">
                    <ol class="m-0 fs-15">
                       Short / Resolution Description is either blank or not satisfying the data clarity criteria. Please map values for these to populate data clarity score
                    </ol>
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="card iom-dq-card">
                <div class="card-body">
                    <ol class="m-0 fs-12">
                        <li>In an automated ticket analysis and resolution system, ticket description and ticket
                            resolution are critical for diagnosing and resolving new tickets. Define standard ways to
                            update ticket summary/resolution descriptions. This would enable effective training of
                            Machine Learning module for Auto ticket resolution.</li>
                        <li>For Ticket Description introduce a Record Producer in the Self Service Portal which will
                            produce series of questions that prompt the user to provide additional clarifying data.
                            Script will be created to take the data collected through the Record Producer and construct
                            a Ticket Description</li>
                    </ol>
                </div>
            </div>
        </div>
    </div>
</div>